import { createReducer } from './utils/reducer';
import { ADD_MESSAGE, CLOSE_MESSAGE, REMOVE_MESSAGE } from '../actions/message';

const initialState = [];

const handlers = {
  [ADD_MESSAGE]: (state, action) => ([
    ...state,
    { ...action.payload },
  ]),
  [CLOSE_MESSAGE]: (state, action) => (
    state.map((message) => message.key === action.key ? { ...message, dismissed: true } : { ...message })
  ),
  [REMOVE_MESSAGE]: (state, action) => state.filter((message) => message.key !== action.key),
};

export default createReducer(initialState, handlers);
